import React, { FC } from 'react'
import { Trans, t } from '@lingui/macro'

import {
  ButtonLight,
  LinkBox,
  ButtonClean,
  Modal
} from 'front-end/src/components'
import './AddCampaignFilterButton.less'
import { EditCampaignFilterModal } from './modals/enrolment-modal/EditCampaignFilterModal'

import classNames from 'classnames'
import {
  CampaignFilterInput,
  CampaignFilterTypeEnum,
  DashboardFilterTypeEnum,
  UserFilterComparator
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { useModal } from 'front-end/src/app/hooks/useModal'
import IconPlus2 from 'front-end/src/components/common/icon/IconPlus2'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'

type Props = {
  onAdd: (filter: CampaignFilterInput) => any
  filterTypeCardsMap: Record<
    CampaignFilterTypeEnum | DashboardFilterTypeEnum,
    string
  >
  className?: string
}

export const AddAudienceFilterButton: FC<Props> = ({
  filterTypeCardsMap,
  className,
  onAdd
}) => {
  const { open, currentModal } = useModal()

  return (
    <>
      <ButtonLight
        className="Filter CampaignAudience__add-a-filter"
        onClick={() =>
          open(FilterTypeModal, { filterTypeCardsMap, className })
            .then((editedFilter) =>
              open(EditCampaignFilterModal, { editedFilter })
            )
            .then(onAdd)
        }
        leftIcon={<IconPlus2 />}
      >
        <Trans>Add a new filter</Trans>
      </ButtonLight>

      {currentModal}
    </>
  )
}

const FilterTypeModal = ({
  filterTypeCardsMap,
  className,
  resolve,
  reject
}) => {
  const { session } = usePublicApiSession()

  return (
    <Modal
      className={classNames('ChooseNewCampaignFilterTypeModal', className)}
      onHide={reject}
      header={t`Select a filter type`}
      controls={
        <>
          <ButtonClean onClick={reject}>
            <Trans>Cancel</Trans>
          </ButtonClean>
        </>
      }
    >
      {Object.entries<any>(filterTypeCardsMap).map(
        ([filterName, cardContent]) => {
          if (cardContent) {
            return (
              <LinkBox
                key={filterName}
                className="Card"
                onClick={() => {
                  let comparator: UserFilterComparator | null = null
                  const backendFilterName = filterName
                  if (
                    filterName === CampaignFilterTypeEnum.duration_comparison
                  ) {
                    comparator = {
                      value: {
                        days: 0
                      },
                      operator: '<',
                      field: 'last_activity_at'
                    }
                  } else if (
                    filterName === CampaignFilterTypeEnum.value_comparison
                  ) {
                    comparator = {
                      field: null,
                      operator: 'is',
                      value: []
                    }
                  }
                  resolve({
                    type: backendFilterName as CampaignFilterTypeEnum,
                    ref_ids: [],
                    comparator,
                    created_at: new Date().toISOString(),
                    created_by: session?.user.id
                  })
                }}
              >
                {cardContent}
              </LinkBox>
            )
          }
          return null
        }
      )}
    </Modal>
  )
}
